import Header from '../../components/Header';  
import Footer from '../../components/Footer'; 
import ServiceNav from '../../components/ServiceNav';
function BusinessOpportunity() { 
	return( 
	<>  
    
   <Header />  
    <main> 
    <section class="tp-hero-area p-relative">
            <div class="tp-hero-wrapper-slider">
               <div class="swiper-container">
                  
               <div class="swiper-wrapper">
                        <div class="swiper-slide pt-20 pb-150 tp-hero-bg-image" data-bg-color="#20536d">
                            <img class="tp-hero-bg" src="../assets/images/banner-bg.png"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    <section class="tp-service-details-area pt-120 pb-120">
            <div class="container">
               <div class="row">
                  <div class="col-lg-4">
                     <div class="tp-service-widget">
                        <div class="tp-service-widget-item mb-40">
                           <ServiceNav activePath="/BusinessOpportunity" />
                        </div> 
                     </div>
                  </div>
                  <div class="col-lg-8">
                     <div class="tp-service-details-wrapper"> 
                        <h3 class="tp-service-details-title">Business Opportunity</h3>
                        <p>We Offer business opportunities with minimal capital investment to empower individuals to pursue entrepreneurship and achieve financial freedom.</p>
                        <p>We focus on the following aspects Clear Value Proposition,Low Barrier to Entry,Proven Success Stories,Training and Support,Scalability,Flexibility,Transparent Business Model,Compliance and Legal Considerations,Continuous Improvement,Ethical Standards.</p>
                        <p>By focusing on these key aspects we help individual to pursue their entrepreneurial dreams and achieve financial independence.</p>
                        <div class="tp-service-details-thumb">
                           <img src="../assets/images/s1.jpeg" alt=""/> 
                        </div>  
 
                     </div>
                  </div>
               </div>
            </div>
         </section>
        
    </main>
    <Footer/>

  </> 
  ); 
  } 
  export default BusinessOpportunity;